import { setDOMUnmanaged } from 'lexical';

import type { NoteEditorTextTone } from '../../config';

// Every block node carries its id in the DOM, where tests, widgets and
// styles find it, and marks the space the note prints before it.
export const markBlockDom = (
  dom: HTMLElement,
  blockId: string,
  spaceBefore: boolean,
) => {
  dom.dataset.noteBlockId = blockId;
  dom.toggleAttribute('data-space-before', spaceBefore);
  return dom;
};

export const markToneDom = (dom: HTMLElement, tone: NoteEditorTextTone) => {
  if (tone) {
    dom.dataset.tone = tone;
  } else {
    delete dom.dataset.tone;
  }
  return dom;
};

// A part of a node's DOM that is not the note's text: the node draws it, or a
// widget renders into it, and the editor neither edits it nor watches it.
export const createAsideDom = <K extends keyof HTMLElementTagNameMap>(
  tag: K,
  role: string,
): HTMLElementTagNameMap[K] => {
  const dom = document.createElement(tag);
  dom.setAttribute(`data-note-${role}`, '');
  dom.setAttribute('contenteditable', 'false');
  setDOMUnmanaged(dom);
  return dom;
};
